import { render, staticRenderFns } from "./ImgUploader2.vue?vue&type=template&id=0ecb0b82&"
import script from "./ImgUploader2.vue?vue&type=script&lang=js&"
export * from "./ImgUploader2.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploader2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports